import { HomeSection } from "./types";

export default async function fetchHomeSections(): Promise<HomeSection[]> {
  const response = await fetch(
    `${process.env.NEXT_PUBLIC_API_BASE_URL}/home?${process.env.NEXT_PUBLIC_API_QUERY_PARAMS}`,
    { cache: "no-store" }
  );
  if (!response.ok) {
    throw new Error("Failed to fetch sections");
  }
  return response.json();
}
